import { Cirus } from "@/classes/Http";
import { IsEnum, IsOptional, IsString, IsUUID, MaxLength, MinLength, validate } from "class-validator";
import { Message } from "element-ui";

export enum InstanceCategory {
    TAYEH = 0,
    SHOP = 1,
    COMPANY = 2,
    SERVICES = 3,
    PERSONAL = 4,
    STORAGE = 5,
    MAGAZINE = 6,
    DEVELOPER = 7,
    DESIGNER = 8,
    CUSTOM = 9
}

const errorMessages : any = {
    name: "لطفا نام فروشگاه را وارد کنید.",
    description: "لطفا توضیحات را صحیح وارد کنید.",
    category: "لطفا دسته بندی را انتخاب کنید.",
    username: "لطفا آیدی فروشگاه را صحیح انتخاب کنید.",
    logo_id: "لوگوی فروشگاه را دوباه بارگذاری کنید.",
}

class CreateInstanceBody {
    constructor (body: CreateInstanceBody) {
        this.name = body.name
        this.description = body.description
        this.category = body.category
        this.username = body.username
        this.logo_id = body.logo_id
    }
    @IsString()
    @MinLength(1)
    @MaxLength(40)
    name: string;

    @IsString()
    @IsOptional()
    description?: string;

    @IsEnum(InstanceCategory)
    category: InstanceCategory = InstanceCategory.SHOP;

    @IsString()
    @MinLength(1)
    @MaxLength(32)
    @IsOptional()
    username?: string;

    @IsUUID()
    @IsOptional()
    logo_id?: string;
}

export async function createInstance(params: CreateInstanceBody) {

    params = new CreateInstanceBody(params);    
    const errors = await validate(params);
    if (errors.length>0)  {
        Message.error(errorMessages[errors[0].property])
        throw new Error("اطلاعات وارد شده صحیح نمی ‌باشد.");
    }
    const path = `/instance`;
    return Cirus.post(path, params, {}, null, process.env.VUE_APP_baseURL, {409: 'آیدی انتخاب شده پیش تر ثبت شده است. لطفا آیدی فروشگاه را تغییر دهید.'});
}